// removed by extract-text-webpack-plugin
module.exports = {"statsModal":"StatsKey__statsModal--CapRm","legend":"StatsKey__legend--2eFTf","legendIcon":"StatsKey__legendIcon--309SS"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/TableControls/StatsKey/StatsKey.css
// module id = cOd7
// module chunks = 47